export const APP_STORE_ID = "6765494592";
export const ANDROID_PACKAGE_NAME = "com.roaveapp";
export const ROAVE_APP_SCHEME = "roave";
export const APP_INSTALL_PROMPT_DISMISSED_KEY = "roave-app-install-prompt-dismissed";

export const IOS_APP_URL =
  `https://apps.apple.com/us/app/roave/id${APP_STORE_ID}?ppid=790d3726-69e1-4973-b030-53957d6a5126`;
export const GOOGLE_PLAY_URL =
  `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE_NAME}&pcampaignid=web_share`;

export type MobilePlatform = "ios" | "android" | "desktop";

export function getMobilePlatform(
  userAgent: string,
  platform = "",
  maxTouchPoints = 0,
): MobilePlatform {
  const ua = userAgent || "";

  if (/android/i.test(ua)) return "android";
  if (/iPad|iPhone|iPod/i.test(ua)) return "ios";
  if (platform === "MacIntel" && maxTouchPoints > 1) return "ios";

  return "desktop";
}

export function getStoreUrlForPlatform(platform: MobilePlatform): string {
  if (platform === "android") return GOOGLE_PLAY_URL;
  return IOS_APP_URL;
}

export function buildRoaveAppUrl(pathname: string, search = ""): string {
  const path = pathname.startsWith("/") ? pathname : `/${pathname}`;
  const query = search && search.startsWith("?") ? search : search ? `?${search}` : "";
  return `${ROAVE_APP_SCHEME}://${path.replace(/^\/+/, "")}${query}`;
}

export function shouldSuppressAppInstallPrompt(pathname: string): boolean {
  return [
    "/booking",
    "/booking-confirmation",
    "/booking-pending",
    "/dashboard",
    "/login",
    "/signup",
    "/auto-login",
  ].some((path) => pathname === path || pathname.startsWith(`${path}/`));
}
